import { useState } from "react"
import { Copy, Check, RefreshCw } from "lucide-react"
import { toast } from "sonner"
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "components/ui/tooltip"

interface MessageActionsProps {
  messageId: string
  content: string
  type: "user" | "agent"
  isStreaming?: boolean
  isError?: boolean
  onRegenerate: (messageId: string) => void
  children: React.ReactNode
}

export function MessageActions({
  messageId,
  content,
  type,
  isStreaming,
  isError,
  onRegenerate,
  children,
}: MessageActionsProps) {
  const [copied, setCopied] = useState(false)
  const isUser = type === "user"
  const hideToolbar = isStreaming || isError

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content)
      setCopied(true)
      toast.success("Copiato negli appunti")
      setTimeout(() => setCopied(false), 2000)
    } catch {
      toast.error("Copia non riuscita")
    }
  }

  const buttonBaseStyle: React.CSSProperties = {
    color: "var(--hexa-text-muted)",
  }
  const handleButtonEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.backgroundColor = "var(--hexa-surface-hover)"
    e.currentTarget.style.color = "var(--hexa-text-primary)"
  }
  const handleButtonLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.backgroundColor = "transparent"
    e.currentTarget.style.color = "var(--hexa-text-muted)"
  }

  return (
    <TooltipProvider delayDuration={200}>
      <div className="group flex flex-col">
        {children}
        {!hideToolbar && (
          <div
            className="flex gap-1 mt-1 opacity-0 group-hover:opacity-100 transition-opacity"
            style={{ alignSelf: isUser ? "flex-end" : "flex-start" }}
          >
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  type="button"
                  onClick={handleCopy}
                  aria-label="Copia"
                  className="w-7 h-7 p-1 rounded-md flex items-center justify-center transition-colors"
                  style={buttonBaseStyle}
                  onMouseEnter={handleButtonEnter}
                  onMouseLeave={handleButtonLeave}
                >
                  {copied ? (
                    <Check className="w-3.5 h-3.5" />
                  ) : (
                    <Copy className="w-3.5 h-3.5" />
                  )}
                </button>
              </TooltipTrigger>
              <TooltipContent>Copia</TooltipContent>
            </Tooltip>

            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  type="button"
                  onClick={() => onRegenerate(messageId)}
                  aria-label="Rigenera"
                  className="w-7 h-7 p-1 rounded-md flex items-center justify-center transition-colors"
                  style={buttonBaseStyle}
                  onMouseEnter={handleButtonEnter}
                  onMouseLeave={handleButtonLeave}
                >
                  <RefreshCw className="w-3.5 h-3.5" />
                </button>
              </TooltipTrigger>
              <TooltipContent>Rigenera</TooltipContent>
            </Tooltip>
          </div>
        )}
      </div>
    </TooltipProvider>
  )
}
